module.exports = __webpack_public_path__ + "img/west-spring-1200x550.74552df8.jpg";